/**
 * "Why this draft": which source each checkable specific came from.
 *
 * Split out of InboundCard for its line ceiling. Note what this box can never do — show an
 * unsourced claim: `draftEvidence` is computed mechanically against the same fact pack that grounded
 * the draft, and a draft stating something no source contains is WITHHELD before it reaches a card.
 */
import { COLORS } from './format';
import type { InboundRequest } from '../../types/taActionBoard';

/**
 * Where the specifics in a model draft come from: "'Munich', 'hybrid' from the kick-off sheet ↗".
 *
 * Rendered only when the server attributed at least one token. The attribution is computed
 * mechanically against the same fact pack that grounded the draft, so this box can say WHY the
 * draft claims what it claims — and an unsourced claim cannot appear here, because it would have
 * been withheld before reaching the card.
 */
export function EvidenceBox({ evidence }: { evidence: InboundRequest['draftEvidence'] }) {
  const rows = (evidence ?? []).filter((row) => row.tokens.length > 0);
  if (rows.length === 0) return null;
  return (
    <div
      className="rounded-lg p-3 text-sm"
      style={{ backgroundColor: COLORS.blueBg, color: COLORS.blueText }}
    >
      <span className="font-semibold">Why this draft: </span>
      {rows.map((row, i) => (
        <span key={`${row.source}-${i}`}>
          {i > 0 && ' · '}
          {row.tokens.map((t) => `“${t}”`).join(', ')} from{' '}
          {row.url ? (
            <a
              href={row.url}
              target="_blank"
              rel="noreferrer"
              className="font-medium underline"
              data-no-toggle
            >
              {row.label} ↗
            </a>
          ) : (
            row.label
          )}
        </span>
      ))}
    </div>
  );
}

